import React from 'react';
import { Analytics } from './Analytics';
import { ErrorBoundary } from './ErrorBoundary';

export interface PrimaryLayoutProps {
  children?: React.ReactNode;
  header: JSX.Element | null;
  footer: JSX.Element | null;
}

export const PrimaryLayout = ({ children, header, footer }: PrimaryLayoutProps) => {
  return (
    <div className="site-content">
      <Analytics />
      <ErrorBoundary>{header}</ErrorBoundary>
      <main className="site-main">
        <span id="maincontentstart" />
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
      <ErrorBoundary>{footer}</ErrorBoundary>
    </div>
  );
};
